import { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

class AffectedReservationsPopup extends Component {
  cancelAction = (e) => {
    e.preventDefault()
    this.props.onCancel()
  }

  downloadReservations = (e) => {
    e.preventDefault()
    this.props.onDownloadReservations()
  }

  cencelReservations = (e) => {
    e.preventDefault()
    this.props.onCancelReservations()
  }

  render() {
    const { isOpen, proceedWithoutCancelling, t } = this.props

    return (
      <div className={`modal modal--confirm is-success ${isOpen ? 'is-active' : ''}`}>
        <div className="modal-background" />
        <div className="modal-content" style={{ width: 'min-content' }}>
          <div className="box">
            <header className="modal__header">
              <span>{t('reservations:affectedReservationsPopup.title')}</span>
              <button
                className="modal-close is-large"
                aria-label="close"
                onClick={this.cancelAction}
              />
            </header>
            <div className="modal__inner">
              {t('reservations:affectedReservationsPopup.description')}
              <br />
              {t('reservations:affectedReservationsPopup.cancelDescription')}
              <div className="modal__section modal__actions">
                {!proceedWithoutCancelling ? (
                  <button
                    className="button button-primary"
                    onClick={this.props.onProceedWithoutCancelling}
                  >
                    {t('reservations:affectedReservationsPopup.proceedWithoutCancelling')}
                  </button>
                ) : (
                  <button className="button button-gray" onClick={this.cancelAction}>
                    {t('common:actions.cancel')}
                  </button>
                )}
                <button className="button button-primary" onClick={this.downloadReservations}>
                  {t('reservations:affectedReservationsPopup.downloadReservations')}
                </button>
                <button className="button button-red" onClick={this.cencelReservations}>
                  {t('reservations:affectedReservationsPopup.cancelReservations')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

AffectedReservationsPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  proceedWithoutCancelling: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  onDownloadReservations: PropTypes.func,
  onCancelReservations: PropTypes.func,
  onProceedWithoutCancelling: PropTypes.func,
  t: PropTypes.func,
}

export default withTranslation(['reservations', 'common'])(AffectedReservationsPopup)
